'use strict';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import moment from 'moment';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {Observable} from 'rxjs/Observable';
import {getUser} from '../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getDomainLink, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable, observeNewOnScope} from '../../core-utilities/rx-utils';


PersonnelDetailController.$inject = [
  '$scope',
  '$translate',
  '$ngRedux',
  '$permissions',
  'AuthService',
  '$ionicViewSwitcher',
  'InPlaceEditorFactory',
  'TeamTypeDomain',
  'PersonDomain',
  'userPresenceService',
  'person',
];

const ONE_MINUTE = 60 * 1000;
const ONE_HOUR_AGO = 60 * ONE_MINUTE;

const VIEW_ACTIONS = {
  canEdit: 'organization_personnel_edit',
};

export function PersonnelDetailController(
  $scope,
  $translate,
  $ngRedux,
  $permissions,
  AuthService,
  $ionicViewSwitcher,
  InPlaceEditorFactory,
  TeamTypeDomain,
  PersonDomain,
  userPresenceService,
  person,
) {
  const teamTypes = {};
  const vm = $scope.personDetails = {};
  vm.person = person;
  vm.teams = PersonDomain.$getTeamsList(getId(person));

  vm.getTeamType = getTeamType;
  vm.onClickEdit = () => {
    vm.personnelEditor.edit();
  };

  const rootState = $ngRedux.getState();
  vm.isUser = getLink(person, 'aliasFor').id === getId(getUser(rootState));

  Observable.of(person)
    .switchMap(() =>
      vm.person && vm.person.hasOwnProperty('aliasFor') && getLink(vm.person, 'aliasFor').id
        ? Observable.merge(
          watchPresence().map(presenceClass => ({presenceClass: presenceClass})),
          getDomainLink(vm.person, 'aliasFor').then(() => ({delegate: vm.person.getDelegatePerson()})),
        ) : Observable.of({delegate: vm.person})
    )
    .subscribe(data =>
      $scope.$evalAsync(() => {
        if (has(data, 'presence'))
          vm.presence = data.presence;
        if (has(data, 'delegate'))
          vm.delegate = data.delegate;
      }));

  initPermission();

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/

  vm.personnelEditor = new InPlaceEditorFactory({
    getModel: () => person,
  });


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function initPermission() {
    if (getLink(person, 'aliasFor').id === AuthService.getUserId()) {
      vm.permissions = {canEdit: true};
    } else if (getLink(person, 'aliasFor').id) {
      $permissions.bindOrg($scope, vm, {
        canEdit: 'organization_access_edit',
      });
    } else {
      $permissions.bindOrg($scope, vm, VIEW_ACTIONS);
    }
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  // TODO(files): remove these after local file saving has been reworked to no longer rename things
  $scope.getNewFilePath = () => 'avatars';

  $scope.getNewFileName = () => getId(person);

  function getTeamType(teamTypeId) {
    if (teamTypes[teamTypeId]) return teamTypes[teamTypeId];

    TeamTypeDomain.$get(teamTypeId).then(teamType => {
      teamTypes[teamTypeId] = teamType;
    });
  }

  function watchPresence() {
    // eslint-disable-next-line max-len
    const lastOnline$ = observeNewOnScope($scope, () => person && person.lastOnline ? person.lastOnline.getTime() : null);
    const lastSeen$ = observeNewOnScope($scope, () => person && person.lastSeen ? person.lastSeen.getTime() : null);
    const interval$ = Observable.interval(0, ONE_MINUTE);

    return Observable
      .combineLatest(
        lastOnline$,
        lastSeen$,
        interval$,
      )
      .switchMap(([lastOnline, lastSeen]) => {
        const now = new Date().getTime() - userPresenceService.INTERVAL;
        const lastObserved = Math.max(lastOnline, lastSeen);
        const updateInterval = now - lastObserved < ONE_HOUR_AGO ? 60 * 1000 : ONE_HOUR_AGO;
        return Observable.merge(
          Observable.of(getPresenceMsg(lastOnline, lastSeen)),
          Observable.interval(updateInterval, updateInterval)
            .map(() => getPresenceMsg(lastOnline, lastSeen)),
        );
      })
      .switchMap(([msg, params]) => $translate(msg, params))
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY));
  }

  function getPresenceMsg(lastOnline, lastSeen) {
    const now = new Date().getTime() - userPresenceService.INTERVAL;
    if (!isNumber(lastOnline) || !isNumber(lastSeen)) {
      // Legacy case to handle any profile that hasn't logged in since the presence system was added
      return ['personnel.presence.legacy.message'];
    } else if (now < lastOnline) {
      return ['personnel.presence.online.message'];
    } else if (now < lastSeen) {
      return ['personnel.presence.away.message'];
    } else {
      const lastObserved = Math.max(lastOnline, lastSeen);
      // TODO(i18n): moment fromNow()
      return ['personnel.presence.last_seen.message', {ago: moment(lastObserved).fromNow()}];
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/PersonnelDetailController.js